// preconnect.service.ts
import { isPlatformBrowser } from '@angular/common';
import { inject,Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreconnectService {
  private readonly platformId = inject(PLATFORM_ID);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const hostname = window.location.hostname;
      let preconnectUrl = 'http://local.wuestenrot.com';

      switch (hostname) {
        case 'staging.pis.wuestenrot.at':
          preconnectUrl = 'https://wuestenrot.staging.web-punks.com';
          break;
        case 'pis.wuestenrot.at':
          preconnectUrl = 'https://directus.pis.wuestenrot.at';
          break;
      }

      // Remove existing preconnect links
      const existingLinks = document.querySelectorAll('link[rel="preconnect"]');
      existingLinks.forEach(link => {
        if (link.getAttribute('href')?.includes('wuestenrot')) {
          link.remove();
        }
      });

      // Add new preconnect link
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = preconnectUrl;
      document.head.appendChild(link);
    }
  }
}
